module.exports = __webpack_public_path__ + "img/logo.0f5a745b.png";